import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import { apiGet, apiPost, apiPut, apiDelete } from "../services/api";
import { toast } from "react-toastify";
import logger from "../utils/logger";
import { BASE_URL } from "../config";
import "./Dashboard.css";
import noImage from '../assets/noimage.png'; 


import "../styles/main.css";
import UserCreationForm from "../components/Forms/UserCreationForm";

const speak = (text, rate = 0.9) => {
  const synth = window.speechSynthesis;
  synth.cancel(); 
  const voices = synth.getVoices();
  const femaleVoice =
    voices.find(v =>
      v.lang.toLowerCase().includes("en") &&
      (v.name.toLowerCase().includes("zira") ||
        v.name.toLowerCase().includes("anya") ||
        v.name.toLowerCase().includes("female") ||
        v.name.toLowerCase().includes("susan"))
    ) || voices.find(v => v.lang === "en-US");

  const utter = new SpeechSynthesisUtterance(text);
  utter.voice = femaleVoice;
  utter.lang = "en-US";
  utter.rate = rate;
  synth.speak(utter);
};

if (window.speechSynthesis.onvoiceschanged !== undefined) {
  window.speechSynthesis.onvoiceschanged = () => {
    window.speechSynthesis.getVoices();
  };
}

const ConfirmToast = ({ message, onConfirm, onCancel }) => {
  return (
    <div  style={{ maxWidth: '600px' }}>
  <div className="mb-3">
    <h6 className="mb-0 text-center meassage-text">{message}</h6>
  </div>
  <div className="d-flex justify-content-center gap-2">

   
    <Button  className='yes-button' size="sm" onClick={onConfirm}>
      Yes
    </Button>
     <Button  className='No-button' size="sm" onClick={onCancel}>
      No
    </Button>
  </div>
</div>

  );
};

const UserCreation = () => {
  // State management
  const [users, setUsers] = useState([]);
  const [userRolesOptions, setUserRolesOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [image, setImage] = useState("");
  const [isListening, setIsListening] = useState(false);
  const inputRef = useRef();
const [isDeleteConfirmationActive, setIsDeleteConfirmationActive] = useState(false);
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5001/"; 

  const initialFormData = {
    Username: "",
    EmailID: "",
    Password: "",
    MobileNumber: "",
    GroupID: "",
    DepartmentID: "",
    RoleID: "",
    UserImage: "",
    Following: [],
    Followers: [],
  };
  const [formData, setFormData] = useState(initialFormData);
  const [editId, setEditId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  

  // Constants
  const BASE_ENDPOINT = "/User";
  const USER_ROLE_ENDPOINT = "/UserRole";
  const DEPARTMENT_ENDPOINT = "/Department";
  const GROUP_ENDPOINT = "/Group";

  useEffect(() => {
    const timer = setTimeout(() => {
      speak("Welcome to User Management. You can add, edit or delete users here.");
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // fetch users
  const fetchUsers = useCallback(async () => {
    setIsLoading(true);
    try {
      logger.debug("Fetching users...");
      const response = await apiGet(`${BASE_ENDPOINT}/GetAllUsers`);

      if (response?.data?.length) {
        const sortedData = [...response.data].sort(
          (a, b) => b.userID - a.userID
        );
        setUsers(sortedData);
        logger.debug("Users fetched:", sortedData);
      } else {
        setUsers([]);
        logger.debug("No Users found.");
      }
    } catch (error) {
      logger.error("Failed to fetch users:", error);
      toast.error(
        <div>
          <strong>Failed to load users</strong>
          <div>{error.message}</div>
        </div>,
        { autoClose: 7000 }
      );
      speak("Failed to load users. Please try again.");
      setUsers([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // fetch user roles
  const fetchUserRole = async () => {
    setIsLoading(true);
    try {
      logger.debug("Fetching user role...");
      const response = await apiGet(`${USER_ROLE_ENDPOINT}/getAll`);

      

      if (response?.data?.length) {
        setUserRolesOptions(response?.data);
        logger.debug("User roles fetched:", response?.data);
      } else {
        setUserRolesOptions([]);
        logger.debug("No User roles found.");
      }
    } catch (error) {
      logger.error("Failed to fetch user roles:", error);
      toast.error(
        <div>
          <strong>Failed to load user roles</strong>
          <div>{error.message}</div>
        </div>,
        { autoClose: 7000 }
      );
      speak("Failed to load user roles. Please try again.");
      setUserRolesOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  // fetch departments
  const fetchDepartmentOptions = async () => {
    setIsLoading(true);
    try {
      logger.debug("Fetching department...");
      const response = await apiGet(`${DEPARTMENT_ENDPOINT}/GetAll`);

      if (response?.data?.length) {
        setDepartmentOptions(response?.data);
        logger.debug("Department fetched:", response?.data);
      } else {
        setDepartmentOptions([]);
        logger.debug("No department found.");
      }
    } catch (error) {
      logger.error("Failed to fetch department:", error);
      toast.error(
        <div>
          <strong>Failed to load department</strong>
          <div>{error.message}</div>
        </div>,
        { autoClose: 7000 }
      );
      speak("Failed to load departments. Please try again.");
      setDepartmentOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  // fetch groups
  const fetchGroupOptions = async () => {
    setIsLoading(true);
    try {
      logger.debug("Fetching group...");
      const response = await apiGet(`${GROUP_ENDPOINT}/GetAll`);

      if (response?.data?.length) {
        setGroupOptions(response?.data);
        logger.debug("Group fetched:", response?.data);
      } else {
        setGroupOptions([]);
        logger.debug("No group found.");
      }
    } catch (error) {
      logger.error("Failed to fetch group:", error);
      toast.error(
        <div>
          <strong>Failed to load group</strong>
          <div>{error.message}</div>
        </div>,
        { autoClose: 7000 }
      );
      speak("Failed to load groups. Please try again.");
      setGroupOptions([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchUserRole();
    fetchDepartmentOptions();
    fetchGroupOptions();
  }, [fetchUsers]);

  const cleanFormData = (e) => {
    console.log("clear form data called");
    setFormData(initialFormData);
    setImage("");
     setEditId(null);
    speak("Form cleared");
  };

  // Error handling
  const handleApiError = (error) => {
    logger.error("API Error:", error);
    const statusCode = error?.response?.status;
    const apiMessage = error?.response?.data?.status;

    const errorMessages = {
      400: apiMessage || "Invalid user data",
      404: "User not found",
      409: "Username already exists",
      500: "Internal server error",
    };

    const errorMessage = errorMessages[statusCode] || "Something went wrong";
    const fullMessage = `Operation Failed. ${errorMessage}`;
    
    toast.error(
      <div>
        <strong>{fullMessage}</strong>
      </div>,
      { autoClose: 7000 }
    );
    speak(fullMessage);
  };

  // Form submission
  const handleSubmit = async (data) => {
    try {
      setIsLoading(true);
      const payload = new FormData();

      

      // Append simple fields
      payload.append("Username", data.Username.trim());
      payload.append("EmailID", data.EmailID.trim());
      if (data.Password) {
        payload.append("Password", data.Password.trim());
      }
      if (data.UserImage) {
        payload.append("UserImage", data.UserImage);
      }
      payload.append("MobileNumber", data.MobileNumber);
      payload.append("GroupID", data.GroupID.value);
      payload.append("DepartmentID", data.DepartmentID.value);
      payload.append("RoleID", data.RoleID.value);
      // Append Followers
      data.Followers.forEach((follower, index) => {
        payload.append(`Followers[${index}].FollowerID`, follower.value);
        payload.append(`Followers[${index}].FollowingID`, 0);
      });

      // Append Following
      data.Following.forEach((followed, index) => {
        payload.append(`Following[${index}].FollowingID`, followed.value);
        payload.append(`Following[${index}].FollowerID`, 0);
      });

      if (editId) {
        payload.append("UserID", editId);
        await apiPut(`${BASE_ENDPOINT}/update`, payload);
        const msg = `User updated successfully!`;
        toast.success(
          <div>
            <strong>{msg}</strong>
          </div>,
          { autoClose: 5000 }
        );
        speak(msg);
        setEditId(null);
      } else {
        payload.append("UserID", 0);
        await apiPost(`${BASE_ENDPOINT}/register`, payload);
        const msg = `User added successfully!`;
        toast.success(
          <div>
            <strong>{msg}</strong>
          </div>,
          { autoClose: 5000 }
        );
        speak(msg);
      }
      cleanFormData();
      await fetchUsers();
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (row) => {
    logger.debug("Editing user:", row);
     toast.dismiss();
  setIsDeleteConfirmationActive(false);
    speak(`Editing user ${row.username}`);
    window.scrollTo(0, 0);
    setFormData((prev) => ({
      Username: row.username ?? "",
      EmailID: row.emailID ?? "",
      Password: "",
      MobileNumber: row.mobileNumber ?? "",
      GroupID: { value: row.groupID, label: row.groupName } ?? "",
      DepartmentID:
        { value: row.departmentID, label: row.departmentName } ?? "",
      RoleID: { value: row.roleID, label: row.roleName } ?? "",
      UserImage: row.userImageUrl ? `${API_BASE_URL}${row.userImageUrl}` : "",
      Following:
        row.following.map((i) => ({
          value: i.followingID,
          label: i.followingName,
        })) ?? [],
      Followers:
        row.followers.map((i) => ({
          value: i.followerID,
          label: i.followerName,
        })) ?? [],
    }));
    setEditId(row.userID);
  };




const handleDelete = async (id) => {
  if (isDeleteConfirmationActive) return; 

  const userToDelete = users.find(u => u.userID === id);
  const confirmMsg = `Are you sure you want to delete the user "${userToDelete?.username}"?`;

  window.speechSynthesis.cancel();
  speak("Are you sure you want to delete the user?"); 
  setIsDeleteConfirmationActive(true);

  toast.info(
    <ConfirmToast
      message={confirmMsg} 
      onConfirm={async () => {
        toast.dismiss();
        try {
          setIsLoading(true);
          await apiDelete(`${BASE_ENDPOINT}/${id}`);
          const msg = 'User deleted successfully!';
          toast.success(<strong>{msg}</strong>, { autoClose: 5000 });
          speak(msg);
          await fetchUsers();
        } catch (error) {
          handleApiError(error);
        } finally {
          setIsLoading(false);
          setIsDeleteConfirmationActive(false); 
        }
      }}
      onCancel={() => {
        toast.dismiss();
        const cancelMsg = `Deletion cancelled for user "${userToDelete?.username}"`;
        speak("User deletion cancelled."); 
        setIsDeleteConfirmationActive(false); 
      }}
    />,
    {
      position: "top-center",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      closeButton: false,
      icon: false,
      className: 'custom-toast',
      bodyClassName: 'custom-toast-body',
      hideProgressBar: true,
    }
  );
};




  const columns = [
    {
      name: "ID",
      selector: (row) => row.userID,
      sortable: true,
      omit: true,
    width: '100px',
   center:true,
    },
    {
      name: "Name",
      selector: (row) => row.username,
      sortable: true,
      cell: row => <span onFocus={() => speak(`User: ${row.username}`)}>{row.username}</span>,
         width: '130px',
   center:true,
    style: {
      borderRight: '1px solid #dee2e6',
    },
    },
    {
      name: "Email ID",
      selector: (row) => row.emailID,
      sortable: true,
        width: '150px',
   center:true,
    style: {
      borderRight: '1px solid #dee2e6',
    },
    },
    {
      name: "User Role",
      selector: (row) => row.roleName,
      sortable: true,
      width: '150px',
      center:true,
       style: {
      borderRight: '1px solid #dee2e6',
    },
    },
    {
      name: "Status",
      selector: (row) => row.isActive ? "Active" : "Inactive",
      sortable: true,
       width: '120px',
      center:true,
      cell: (row) => (
        <span
          className={`badge ${row.isActive ? "text-success" : "texts-danger"
            }`}
          onFocus={() => speak(`${row.isActive ? "Active" : "Inactive"} user`)}
        >
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
       style: {
      borderRight: '1px solid #dee2e6',
    },
    },

    {
      name: "Department Name",
      selector: (row) => row.departmentName,
      sortable: true,
        width: '200px',
      center:true,
       style: {
      borderRight: '1px solid #dee2e6',
    },
    },
    {
      name: "Group",
      selector: (row) => row.groupName,
      sortable: true,
         width: '130px',
      center:true,
       style: {
      borderRight: '1px solid #dee2e6',
    },
    },
{
  name: "User Image",
      width: '150px',
      center:true,
  cell: (row) => (
    <img
      src={row.userImageUrl && row.userImageUrl !== "N/A" ? `${BASE_URL}${row.userImageUrl}` : noImage}
      className="tblimage"
      alt={row.userImageUrl && row.userImageUrl !== "N/A" ? `${row.username}'s profile` : "No profile image"}
      title={row.userImageUrl && row.userImageUrl !== "N/A" ? `${row.username}'s profile` : "No profile image"}
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = noImage;
      }}
    />
  ),
   style: {
      borderRight: '1px solid #dee2e6',
    },
},

{
  name: "Actions",
    width: '120px',
  center: true,
  cell: (row) => (
    <>
      <Button 
        variant="outline-warning custompadding" 
        size="sm me-2" 
        onClick={() => handleEdit(row)}
        onFocus={() => speak(`Edit ${row.username} user`)}
      >
        <i className="bi bi-pencil"></i>
      </Button>{" "}
      <Button
        variant="outline-danger custompadding"
        size="sm"
        onClick={() => handleDelete(row.userID)}
        onFocus={() => speak(`Delete ${row.username} user`)}
        disabled={isDeleteConfirmationActive} // ✅ Disable if a confirmation is active
      >
        <i className="bi bi-trash"></i>
      </Button>
    </>
  ),
}
,
  ];

  const filteredUsers = useMemo(() => {
    if (!filterText) return users;
    return users.filter((user) =>
      Object.values(user).some((value) =>
        value?.toString().toLowerCase().includes(filterText.toLowerCase())
      )
    );
  }, [filterText, users]);

  return (
    <div className="container mt-4">
      <div className="row custombox">
        <div className="p-4 mb-4">
          <UserCreationForm
            onSubmit={handleSubmit}
            cleanFormData={cleanFormData}
            initialData={formData}
            isLoading={isLoading}
            isEdit={!!editId}
            userRolesOptions={userRolesOptions}
            departmentOptions={departmentOptions}
            groupOptions={groupOptions}
            users={users}
          />
        </div>
      </div>
      <div className="mt-4 row px-2">
        <Form.Control
          type="text"
          placeholder="Search user..."
          onChange={(e) => {
            setFilterText(e.target.value);
            if (e.target.value) {
              speak(`Searching for ${e.target.value}`);
            }
          }}
          style={{ width: "300px" }}
          onFocus={() => speak("Search users input field")}
        />{" "}
        {filterText && (
          <small className="ms-2 text-muted">
            Search result - {filteredUsers.length}
          </small>
        )}
      </div>
      {isLoading && !users.length ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="btn-primary" />
          <p className="mt-2">Loading users...</p>
        </div>
      ) : (
         <div className="row">
        <div className="card shadow-sm rounded-4 py-4 mx-0 px-2 border-0 bg-white mb-4 mt-2">
          <DataTable
            columns={columns}
         
                             data={filteredUsers.map((dept, idx) => ({
  ...dept,
    _rowIndex: idx, 
  }))}
            pagination
      
            striped
              className="p-datatable-striped customuser-data-table   dashboard-table"
            responsive
              customStyles={{
              table: {
                style: {
             
      fontWeight: '600',
      fontSize: '14px',
      backgroundColor: '#f8f9fa',
      textAlign: 'center',
                },
              },
              headRow: {
                style: {
                  backgroundColor: "#04364A!important",
                  minHeight: "48px",
                },
              },
              headCells: {
                style: {
                  padding: "10px 14px",
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "white",
                  textTransform: "uppercase",
                },
              },
              rows: {
                style: {
                  borderBottom: "1px solid #fdfdfd",
                  "&:hover": {
                    backgroundColor: "#fdfdfd",
                  },
                },
              },
              cells: {
                style: {
                  padding: "10px 14px",
                  fontSize: "14px",
                  color: "#334155",
                },
              },
            }}
                                conditionalRowStyles={[
     {
    when: (row) => row._rowIndex % 2 === 0, 
    style: { backgroundColor: '#f2f2f2' },
  },
  {
    when: (row) => row._rowIndex % 2 !== 0,
    style: { backgroundColor: '#ffffff' },
  },
  ]}


            onRowClicked={(row) => speak(`User: ${row.username}`)}
          />
        </div></div>
      )}
    </div>
  );
};

export default UserCreation;